import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const EmailPage: React.FC = () => {
    return (
        <iframe
            title="Почта"
            src="https://mail.x.media-agency.kz/?token=yassi@media"
            style={{ width: '100%', height: '100vh', border: 'none' }}
        ></iframe>
    );
};

export default EmailPage;
